<template>
  <div class="calendar-schedule">
    <!-- 周日历 -->
    <div class="calendar-title m_b8">
      <span class="current-month m_l8 m_r16">{{currentMonth}}</span>
      <div class="change-week">
        <xin-icon xin-type="arrow-right-s-line" class="left f_s14 c_pointer m_r4 sk--hover-text" @click="handleChangeWeek('pre')" />
        <span class="today" :class="currentRecordData.isToday?'no':'c_pointer sk--hover-text'" @click="handleChangeToToday">{{$xinI18n('今天','Resume-ListHOCFn-jintian')}}</span>
        <xin-icon xin-type="arrow-right-s-line" class="c_pointer f_s14 m_l4 sk--hover-text" @click="handleChangeWeek('next')" />
      </div>
      <span v-if="showAddReminderBtn" class="add-reminder f_s16 c_pointer sk--hover-light9-only-bg sk--hover-text " @click="handlerAddReminder()">
        <xin-icon xin-type="draft-line" />
      </span>
    </div>
    <ul class="week-title m_b8">
      <li v-for="(text,index) in WEEKDAYS" :key="index">{{text}}</li>
    </ul>
    <ul class="week-date m_b16" v-loading="loading">
      <template v-if="recordsList.length">
        <li
          class="c_pointer"
          v-for="(item,index) in recordsList"
          :key="index"
          :class="{
            active: currentRecordData.time == item.time,
            err: appSetting.attendance==1 && item.situation === -1,
            qingjia: appSetting.attendance==1 && item.situation === 1,
            xin: item.isPayDay && item.isWorkday === 1
          }"
          @click="handleChangeDay(item)"
        >
          <p class="day" :class="{'sk-bg':currentRecordData.time == item.time}">{{item.date}}</p>
          <p class="yinli" v-if="lang==='zh'">{{item.lunarShow}}</p>
          <span v-if="item.isPayDay && item.isWorkday === 1" class="faxin sk-text">{{$xinI18n('薪','home-xin')}}</span>
          <span v-if="item.isWorkday === 0" class="xiu">{{$xinI18n('休','Common-week-xiu')}}</span>
        </li>
      </template>
    </ul>

    <!-- 考勤数据 标准日历不展示 -->
    <AttendanceOverview
      v-if="hasEmployeeAccount && isAttendanceCalendar && appSetting.attendance == 1"
      :apply-list="applyList"
      :currentRecordData="currentRecordData"
      :attendance-statistics="attendanceStatistics"
      :sign-time-list="currentRecordData.detailInfo ? currentRecordData.detailInfo.signTimeList : []"
    />

    <EmployeeOverviewStatistics
      v-if="hasAdminAccount && currentDate"
      :date="currentDate"
    />

    <ReminderList
      v-if="currentDate"
      ref="reminderListRef"
      :date="currentDate"
      :is-today="currentRecordData.isToday"
      @edit="handlerAddReminder"
      @delete="handlerDeleteReminder"
      @hideAddRimendBtn="($event)=>{showAddReminderBtn = $event}"
    />

  </div>
</template>

<script lang="ts">
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import {namespace} from 'vuex-class';
  import moment from "moment"
  import {XinMessage, XinModalService} from '@xin/xin-ui';
  import {HomeApi} from '@/module/home/service/home-api.service';
  import {HomeReminder} from '@/module/home/entities/home-reminder';
  import {OpenDetail} from '@/module/home/entities/open-detail';
  import AttendanceOverview from "./attendance-overview.vue"
  import EmployeeOverviewStatistics from "./employee-overview-statistics.vue"
  import ReminderAdd from "./reminder-add.vue"
  import ReminderList from "./reminder-list.vue"
import { lowerFirst } from 'lodash-es';

  const moduleInfra = namespace('moduleInfra');

  @Component({
    components:{
      AttendanceOverview,
      EmployeeOverviewStatistics,
      ReminderList
    }
  })
  export default class CalendarSchedule extends Vue {
    //身份标识
    @moduleInfra.Getter('getHasAdminAccount') public hasAdminAccount!: number;
    @moduleInfra.Getter('getHasEmployeeAccount') public hasEmployeeAccount!: number;

    @Prop({default:()=>[]})
    applyList!:any

    @Prop({default:()=>({})})
    appSetting!:any

    lang = window.XinI18n.getLangCache() || 'zh'
    loading = false
    showAddReminderBtn = false
    startDate = ''
    endDate = ''
    calendarType = ''
    recordsList = []
    currentRecordData:any = {} //选中日期数据
    attendanceStatistics:any = {} //月异常考勤统计数据
    WEEKDAYS = [
      this.$xinI18n("日", "Attendance-calendar-week-0"),
      this.$xinI18n("一", "Attendance-calendar-week-1"),
      this.$xinI18n("二", "Attendance-calendar-week-2"),
      this.$xinI18n("三", "Attendance-calendar-week-3"),
      this.$xinI18n("四", "Attendance-calendar-week-4"),
      this.$xinI18n("五", "Attendance-calendar-week-5"),
      this.$xinI18n("六", "Attendance-calendar-week-6"),
    ];
    openDetail: OpenDetail = {} as OpenDetail;

    get currentMonth(){
      const formatTemp = this.lang == 'zh' ? 'YYYY年MM月' : 'YYYY/MM'
      return this.currentRecordData.time ? moment(this.currentRecordData.time*1000).format(formatTemp) : ''
    }

    get currentDate(){
      return this.currentRecordData.time ? moment(this.currentRecordData.time*1000).format('YYYY/MM/DD') : ''
    }

    get todayIndexInWeek(){
      if(this.recordsList.length){
        return this.recordsList.findIndex((i:any)=>i.isToday==1)
      }else{
        return -1
      }
    }

    get isAttendanceCalendar(){
      return this.calendarType == 'attendance'
    }

    created(){

      this.init();

      if(this.hasAdminAccount){
        HomeApi.getOpenDetail().then(result => {
          this.openDetail = result;
        });
      }
    }

    async init(){
      this.startDate = moment().subtract(moment().day(),'days').format('YYYYMMDD')
      this.endDate = moment().add(6-moment().day(),'days').format('YYYYMMDD')

      const res = await this.getAttendanceCalendar()
      if(res){
        //切换到今天
        this.handleChangeToToday()
      }
    }

    //获取日历
    getAttendanceCalendar(){
      this.loading = true
      const ajaxUrl = this.hasEmployeeAccount ? '/employee-pc/service/home/ajax-get-calendar' : '/xsearch/service/admin/home/ajaxGetCalendar'
      return HomeApi.ajaxGetAttendanceCalendar(ajaxUrl,{
        startDate:this.startDate,
        endDate:this.endDate
      }).then((data:any)=>{
        if(data){
          this.calendarType = data.calendarType
          this.recordsList = data.records
          this.loading = false
        }
        return data
      }).catch(()=>{
        return false
      })
    }

    //切换周
    async handleChangeWeek(type:'pre'|'next'){

      if(this.loading) return

      this.XrxsTracker.$track('a_homeClickCalendarSchedule','',type)

      if(type == 'pre'){
        this.startDate = moment(this.startDate,'YYYYMMDD').subtract(7,'days').format('YYYYMMDD')
        this.endDate = moment(this.endDate,'YYYYMMDD').subtract(7,'days').format('YYYYMMDD')
      }else{
        this.startDate = moment(this.startDate,'YYYYMMDD').add(7,'days').format('YYYYMMDD')
        this.endDate = moment(this.endDate,'YYYYMMDD').add(7,'days').format('YYYYMMDD')
      }
      //请求下一周或者上一周 周日历
      const res = await this.getAttendanceCalendar()
      if(res){
        this.handleChangeDay(this.recordsList[1])
      }
    }

    //切换到今天
    async handleChangeToToday(){
      this.XrxsTracker.$track('a_homeClickCalendarSchedule','','today')

      //没有日历或者不是今天直接返回
      if(!this.recordsList.length || this.currentRecordData.isToday) return

      //当前周里有今天直接取，否则接口请求
      if(this.todayIndexInWeek != -1){
        this.handleChangeDay(this.recordsList[this.todayIndexInWeek])
      }else{
        this.init()
      }
    }

    //点击事件--点击更改选中日期
    async handleChangeDay(item:any){
      console.log(item,'0000');
      this.currentRecordData = item
      //根据选中日期展示所在帐套月内异常数据
      this.attendanceStatistics = item.attendanceStatistics

      //当前天详细考勤数据
      if(this.isAttendanceCalendar){
        if(!item.containsApproveflowData){
          //请求审批数据
          await HomeApi.ajaxGetAttendanceCalendarApproveflow({
            date: item.time,
            employeeId: "",
          }).then((data:any)=>{
              if(data){
                const statusListTemp = this.currentRecordData.detailInfo.statusList
                item.detailInfo = {
                  ...this.currentRecordData.detailInfo,
                  flowList: data,
                }
                item.containsApproveflowData = 1
                this.currentRecordData = item
              }
            })
        }
      }

      this.XrxsTracker.$track('a_homeClickCalendarSchedule','','date')
    }

    //添加编辑备忘
    handlerAddReminder(srcReminder?: HomeReminder) {

      this.XrxsTracker.$track('a_homeClickCalendarSchedule','',srcReminder ? 'reminder-edit' : 'reminder-add')

      let isLoading = false;
      const modal = XinModalService.create({
        xinVisible: true,
        xinComponent: ReminderAdd,
        xinComponentProps: {
          selectedDate: this.currentDate,
          openDetail: this.openDetail,
          srcReminder
        },
        xinDialogProps: {
          title: window.$xinI18n('添加备忘','Home-tianjiabeiwang'),
          width: '720px'
        },
        xinStore: this.$store,
        xinModalFooter: [
          {
            text: window.$xinI18n('取消','Common-quxiao'),
            onClick: () => {
              modal.close();
            }
          },
          {
            text: window.$xinI18n('确定','Common-queding'),
            loading: () => isLoading,
            disabled: (instance: any) => {
              if (instance && instance.reminderList && instance.reminderList.reminderData) {
                return instance.reminderList.reminderData.replace(/(^\s+)|(\s+$)/g, '').length == 0;
              }
              return true;
            },
            buttonProps: {
              type: 'primary'
            },
            onClick: (instance: any) => {
              isLoading = true;
              instance.handlerSaveReminder((t: boolean) => {
                isLoading = false;
                if (t) {
                  modal.close();
                  this.getHomeReminders();
                }
              });
            }
          }
        ]
      });
    }
    //删除备忘
    handlerDeleteReminder(item: HomeReminder) {
      if (item && item.reminderId) {

        this.XrxsTracker.$track('a_homeClickCalendarSchedule','','reminder-delete')

        HomeApi.deleteReminder(item.reminderId).then(result => {
          if (result.status) {
            XinMessage.success(window.$xinI18n('备忘删除成功','Home-beiwangshanchuchenggong'));
            this.XrxsTracker.$track('a_homeCalendar','','reminderDel');
            this.getHomeReminders();
          }
        });
      }
    }

    getHomeReminders(){
      const ref:any = this.$refs.reminderListRef
      ref && ref.init()
    }
  }
</script>

<style lang="scss" scoped>
.calendar-schedule{
  overflow: hidden;
  margin-top: 8px;
  padding: 16px 8px 0;
  background: #fff;
  border-radius: 4px;
  .calendar-title{
    position: relative;
    display: flex;
    align-items: center;
    .current-month{
      font-size: 16px;
      color: var(--xs-text-color-primary);
      font-weight: 700;
    }
    .change-week{
      font-size: 12px;
      .today{
        color: var(--xs-text-color-primary);
        &.no{
          color: var(--xs-text-color-gray);
          cursor: not-allowed;
        }
      }
      .xin-icon.left{
        transform: rotate(180deg);
      }
    }
    .add-reminder{
      position: absolute;
      right: 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 20px;
      border-radius: 2px;
    }
  }

  .week-title{
    display: flex;
    li{
      flex: 1;
      text-align: center;
      color: var(--xs-text-color-gray);
      font-weight: 400;
    }
  }
  .week-date{
    display: flex;
    min-height: 40px;
    &::v-deep .el-loading-mask{
      background: rgba(#fff,.5);
      .el-loading-spinner{
        margin-top: -12px;
        .circular{
          width: 24px;
          height: 24px;
        }
      }
    }
    li{
      position: relative;
      flex: 1;
      text-align: center;
      color: var(--xs-text-color-gray);
      font-weight: 400;
      &.active .day{
        width: 20px;
        height: 20px;
        display: inline-block;
        border-radius: 10px;
      }
      &.xin .day{
        color: var(--xs-text-color-primary);
      }
      &.err .yinli::after,&.qingjia .yinli::after{
          content: '';
          display: inline-block;
          position: absolute;
          bottom: -5px;
          left: 50%;
          transform: translateX(-50%);
          width: 4px;
          height: 4px;
          border-radius: 2px;
          background: $sysErrorColor;
        }
      &.qingjia .yinli::after{
        background: $sysSuccessColor;
      }
      .day{
        font-size: 16px;
        font-weight: 700;
        color: var(--xs-text-color-gray);
        font-family: D-DIN;
        line-height: 20px;
      }
      .yinli{
        position: relative;
        margin-top: 2px;
        font-size: 12px;
      }
      .faxin,.xiu{
        position: absolute;
        top: -8px;
        right: 8px;
        font-size: 12px;
        transform: scale(.8);
      }

    }
  }
}
</style>:
